import type { Variant } from "@raumagarn/formatters";
import { withSearchParams } from "@trydig/ui/next";
import { YarnPreviewCard } from "~/components/ui/YarnSelector/YarnPreviewCard";
import type { TYarnSelector } from "~/components/ui/YarnSelector/YarnSelector";
import { useVariantContext } from "~/features/products/VariantContext";
import styles from "./yarn-preview-grid.module.css";

export const YarnPreviewGrid = withSearchParams<
	TYarnSelector & {
		setPreviewOpen?: (open: boolean) => void;
		onVariantSelect?: (variant: Variant) => void;
	}
>(({ showAll = true, setPreviewOpen, searchParams, onVariantSelect }) => {
	const { currentVariant, variants } = useVariantContext();

	const displayedYarns = showAll ? variants : variants.slice(0, 14);

	return (
		<div className={styles.yarns}>
			{displayedYarns?.map((yarn) => (
				<YarnPreviewCard
					setPreviewOpen={setPreviewOpen}
					yarn={yarn}
					selected={currentVariant?.displayItemId === yarn.displayItemId}
					selectYarn={() => {
						onVariantSelect?.(yarn);
						searchParams.set("variant", yarn.displayItemId);
						// if ("select" in yarn) {
						// 	yarn.select?.();
						// }
					}}
					key={yarn.displayItemId}
				/>
			))}
		</div>
	);
});
